const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/user/reducers/user.reducer.js